var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"editorWrapper",staticClass:"editorWrapper",on:{"focus":_vm.doFocus}},[_c('editor',{ref:"tuieditor",attrs:{"initialValue":_vm.value,"options":_vm.defaultOptions,"initialEditType":"wysiwyg"},on:{"change":_vm.doChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }